import { Subject } from 'rxjs';

import { Injectable } from '@angular/core';
import { XAPIHelperService } from './xAPI-helper.service';
@Injectable()
export class ProductViewHelperService {

	selectedItemId = new Subject();
	changesNotSaved = new Subject();
	pskillUrlLinkValidation = new Subject<any>();
	pskillAnsSaved: Subject<any> = new Subject<any>();
	collabSkillAnsSaved: Subject<any> = new Subject<any>();
	saveAlertAction: Subject<boolean> = new Subject<boolean>();
	saveRecordedAudio = new Subject();
	logOutCalled = new Subject();
	saveAlertActionOnLogout = new Subject();
	stopAllOtherAudiosOnPlayingOneAudio = new Subject<number>();
	TEST_TYPE_LABEL: string = "Test type";
	activityEventsSubject = new Subject<any>();
    activityCloseCalled = new Subject();
    saveAlertActionOnActivityClose = new Subject();

    private _isTeacher: boolean;
	private xapiLO: any;
	private xapiLOAnalytics: any;
	private initParams: any;
	private scoreObject: any;
	private navigationMeta: any;
	scoreDetailFormatTypes = {
		mock: "MOCK",
		none: "none"
	}
	productModelTypes = {
		test: 'TEST'
	}

	isCBPClass = false;
	classId;
	isTestTypeProduct = false;
	
	constructor(
		private xAPIHelperService: XAPIHelperService
	) { }

	set isTeacher(isTeacher) {
		this._isTeacher = isTeacher;
	}
	get isTeacher() {
		return this._isTeacher;
	}

	setNavigationMeta(navigationMeta) {
		this.navigationMeta = navigationMeta;
	}

	setXAPIRunnerObject(initParams, eventCallbacks) {
		let options = {
			returnInstance: true
		}
		this.xapiLO = this.xAPIHelperService.setXAPIRunnerObject(initParams, eventCallbacks, options);

	}

	setXAPIAnalyticsObject(analyticsDataObj) {
		let options = {
			returnInstance: true,
			eventHandlers: {
				errorCallback: this.xAPIHelperService.handleXAPIAnalyticsError,
			}
		}
		this.xapiLOAnalytics = this.xAPIHelperService.setXAPIAnalyticsObject(analyticsDataObj, options);
	}

	getXAPIRunnerObject() {
		return this.xapiLO;
	}

	getXAPIAnalyticsObject() {
		return this.xapiLOAnalytics;
	}

	setLOInitParams(initParams) {
		this.initParams = initParams;
	}

	getLOInitParams() {
		return this.initParams;
	}

	setScoreObject(scoreObject) {
		this.scoreObject = scoreObject;
	}

	getScoreObject() {
		return this.scoreObject;
	}

	resetScoreObject() {
		this.scoreObject = undefined;
	}

	// Get the test type tags from tags mapping.
	getTestTypeTags(mappedTags) {
		return mappedTags && mappedTags
			.filter((tag) => {
				let decodedTag = decodeURIComponent(tag.split("/")[0]);
				return decodedTag === this.TEST_TYPE_LABEL;
			})
			.map((tag) => {
				/*since tag was encoded in products.service to suffice for the use-case of tag name comprising '/', we will decode the same over here to get the actual tag names.*/
				return decodeURIComponent(tag.split("/")[1]);
			})
	}

	// Function to check test type product
	isTestTypeComponent(bundleProduct) {
		const resultsDisplayScoreDetailFormat = bundleProduct['results-display'] && bundleProduct['results-display']['score-detail-format'] ? bundleProduct['results-display']['score-detail-format'] : this.scoreDetailFormatTypes.none;
		const productModelType = bundleProduct['ext-product'] && bundleProduct['ext-product']['model'];

		return resultsDisplayScoreDetailFormat === this.scoreDetailFormatTypes.mock || productModelType === this.productModelTypes.test;
	}

	private isStateUseable(stateObject: any = {}) {
		const referenceClassId = stateObject.CBPClassId;
		return (!this.isCBPClass || referenceClassId === this.classId) &&
			(!this.isTestTypeProduct || (!referenceClassId || referenceClassId === this.classId));
	}

	public getIsCBPClass() {
		return this.isCBPClass;
	}

	public setIsCBPClass(isCBPClass, classId) {
		this.isCBPClass = isCBPClass;
		this.classId = classId;
	}


}